import {
  isEmpty,
  get,
} from '@/utils/lodash';

export default {
  isShoppingCartEmpty(state) {
    return isEmpty(get(state.shoppingCart, 'products'));
  },
};
